import { QueryConfig } from "store/utils/query-config";

export const chatBotsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
